// extracted by mini-css-extract-plugin
export default {"container":"dq-z","heading":"eq-z","text":"fq-z","info":"gq-z","link":"hq-z","fullMaxWidth":"iq-z"};